<i2g-form-master *ngIf="form" [form]="form" class="form">
  <i2g-textarea-field
    fieldId="message"
    [label]="messageLabel"
    [showLabel]="true"
    [fieldControl]="form.get(formKeys.MESSAGE)"
    [placeholder]="messagePlaceholder"
    [errorMessages]="messageErrorMessages"
    [maxlength]="messageMaxLength"
    rows="7"
    class="message-field"
    data-e2e-id="message-field"
  >
  </i2g-textarea-field>

  <button
    type="submit"
    class="submit"
    i2gButton
    buttonStyle="emphasis"
    [disabled]="isSubmitProcessing"
    data-e2e-id="message-submit"
    (click)="onSubmitForm()"
  >
    <!-- couldn't use (submitForm) output event from <form> because the validation occurs after submit is clicked -->
    <i2g-icon
      *ngIf="isSubmitProcessing"
      class="loading-icon"
      name="dotted-spinner"
      size="custom"
    ></i2g-icon>
    {{ isSubmitProcessing ? processingLabel : buttonLabel }}
  </button>
</i2g-form-master>
